{
  "MissingData": {
    "name": "Missing data",
    "color": "rgba(255, 193, 7, 0.8)"
  },
  "ContractedPowerExceeded": {
    "name": "Contracted power exceeded",
    "color": "rgba(158, 27, 50, 1)"
  },
  "ContractedFeedInPowerExceeded": {
    "name": "Contracted feed-in power exceeded",
    "color": "rgba(158, 27, 50, 1)"
  },
  "Disconnected": {
    "name": "Disconnected",
    "color": "rgba(220, 53, 69, 0.8)"
  }
}